import React from "react";
import $ from "jquery";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import LeftSidebar from "../../components/layout/leftMenu.jsx";
import Header from "../../components/layout/header.jsx";
import HeaderCandidate from "../../components/layout/header-candidate.jsx";
import { useState, useEffect } from "react";
import { backendApi } from "../../api/apiService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LeftMenu01 from "../../components/layout/leftMenu01.jsx";
import Loading from "../../images/loading.gif";

function UpdatePassword() {
  var user_id = localStorage.getItem("userId");
  var candidate_id = localStorage.getItem("candidateId");
  const location = useLocation();
  const navigate = useNavigate();
  const lengthRegex = /.{8,}/;
  const uppercaseRegex = /[A-Z]/;
  const lowercaseRegex = /[a-z]/;
  const digitRegex = /[0-9]/;
  const specialCharRegex = /[@#$%^&+=!]/;
  const [changePasswordHidden, setChangePasswordHidden] = useState(true);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newConfirmPassword, setNewConfirmPassword] = useState("");
  const [passwordValid, setPasswordValid] = useState(false);
  const [passwordsMatch, setPasswordsMatch] = useState(false);
  const [showPassword, setShowPassword] = useState(true);
  const [isloading, setIsloading] = useState(false);
  useEffect(() => {
    $("#changepassword").click(function () {
      setChangePasswordHidden(false);
    });
    setCurrentPassword("");
    setNewPassword("");
    setNewConfirmPassword("");
  }, [changePasswordHidden]);

  const changePassword = (e) => {
    if (!passwordsMatch || !passwordValid) {
      return;
    }
    e.preventDefault();
    if (currentPassword === "") {
      toast.warn("Enter current password", { containerId: "B" });
      return false;
    } else if (newPassword === "") {
      toast.warn("Enter new password", { containerId: "B" });
      return false;
    } else if (newConfirmPassword === "") {
      toast.warn("Enter to reconfirm new password", { containerId: "B" });
      return false;
    } else if (newPassword !== newConfirmPassword) {
      toast.warn("New password and confirm password must be same", {
        containerId: "B",
      });
      return false;
    } else if (newPassword.length < 8) {
      toast.warn("Password must be at least 8 characters long", {
        containerId: "B",
      });
      return false;
    } else if (newPassword.length > 20) {
      toast.warn("Password should not exceed more than 20 Characters", {
        containerId: "B",
      });
      return false;
    }
    setIsloading(true);
    if (location.state.type === "user") {
      var req = {
        functionName: "changePassword",
        sec_user_id: user_id,
        currentPassword: currentPassword,
        newPassword: newPassword,
      };
      backendApi(req)
        .then((response) => {
          if (response.success === "1") {
            toast.success("Password changed succesfully", { containerId: "B" });
            setCurrentPassword("");
            setNewPassword("");
            setNewConfirmPassword("");
            setTimeout(() => {
              navigate("/dashboard/dashboardMain");
            }, 1000);

            // toast.success(response.successMessage, { containerId: 'A' });
            // $("#change_password").attr("hidden", true);
          } else {
            toast.warn("Please Check Current Password", {
              containerId: "B",
            });
            document.getElementById("CurrentPassword").focus();
            // toast.warn(response[0]?.message, { containerId: "B" });
          }
        })
        .finally(() => {
          setIsloading(false);
        });
    } else {
      changeCandidatePassword();
    }
  };

  const changeCandidatePassword = () => {
    var req = {
      functionName: "changeCandidatePassword",
      sec_user_id: candidate_id,
      currentPassword: currentPassword,
      newPassword: newPassword,
    };
    backendApi(req)
      .then((response) => {
        if (response.success === "1") {
          toast.success("Password changed succesfully", { containerId: "B" });
          setCurrentPassword("");
          setNewPassword("");
          setNewConfirmPassword("");
          setTimeout(() => {
            navigate("/dashboard/candidateDashboard");
          }, 1000);

          // toast.success(response.successMessage, { containerId: 'A' });
          // $("#change_password").attr("hidden", true);
        } else {
          toast.warn("Please Check Current Password", {
            containerId: "B",
          });
          document.getElementById("CurrentPassword").focus();
          // toast.warn(response[0]?.message, { containerId: "B" });
        }
      })
      .finally(() => {
        setIsloading(false);
      });
  };

  const getValidationMessage = () => {
    if (!lengthRegex.test(newPassword)) {
      return "Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one digit, and one special character.";
    }
    if (!uppercaseRegex.test(newPassword)) {
      return "Password must include at least one uppercase letter.";
    }
    if (!lowercaseRegex.test(newPassword)) {
      return "Password must include at least one lowercase letter.";
    }
    if (!digitRegex.test(newPassword)) {
      return "Password must include at least one digit.";
    }
    if (!specialCharRegex.test(newPassword)) {
      return "Password must include at least one special character.";
    }
    return "";
  };
  const validatePasswordStrength = (password) => {
    const isStrong =
      lengthRegex.test(password) &&
      uppercaseRegex.test(password) &&
      lowercaseRegex.test(password) &&
      digitRegex.test(password) &&
      specialCharRegex.test(password);
    setPasswordValid(isStrong);
  };
  useEffect(() => {
    if (passwordValid && newPassword === newConfirmPassword) {
      setPasswordsMatch(true); // Matched
    } else {
      setPasswordsMatch(false); // Not matched
    }
  }, [newPassword, newConfirmPassword]);
  const handlePasswordChange = (e) => {
    const password = e.target.value;
    setNewPassword(password);
    validatePasswordStrength(password);
  };
  const [menuClick, setMenuClick] = useState(false);
  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };
  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        {location.state.type === "user" ? (
          <LeftSidebar menuClick={menuClick} closeMenu={closeMenu} />
        ) : (
          <LeftMenu01 menuClick={menuClick} closeMenu={closeMenu} />
        )}
        <div className="content-wrapper">
          {location.state.type === "user" ? (
            <Header
              Header="Change Password"
              toggleMenu={toggleMenu}
              menuClick={menuClick}
            />
          ) : (
            <HeaderCandidate
              Header="Candidate Dashboard"
              toggleMenu={toggleMenu}
              menuClick={menuClick}
            />
          )}
          <div className="xilliContent">
            <ToastContainer
              enableMultiContainer
              containerId={"B"}
              position="bottom-right"
              autoClose={1500}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
            <div className="card main-card">
              <div className="card-body">
                <form
                  onSubmit={changePassword}
                  className="col-xl-6 mx-auto py-4"
                >
                  <div className="row mb-2">
                    <div class="form-group col-md-12 position-relative">
                      <label className="form-label">
                        Current Password<span class="text-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        type={showPassword ? "password" : "text"}
                        id="CurrentPassword"
                        placeholder="Enter Current Password"
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        value={currentPassword}
                        tabIndex="0"
                      />
                      {currentPassword && (
                        <span className="showPswd">
                          {!showPassword ? (
                            <FaEye
                              title="Hide Password"
                              onClick={() => setShowPassword(!showPassword)}
                            />
                          ) : (
                            <FaEyeSlash
                              title="Show Password"
                              onClick={() => setShowPassword(!showPassword)}
                            />
                          )}
                        </span>
                      )}
                    </div>

                    <div class="form-group col-md-12">
                      <label className="form-label">
                        New Password<span class="text-danger">*</span>
                      </label>

                      <input
                        className="form-control"
                        type="password"
                        placeholder="Enter New Password"
                        onChange={handlePasswordChange}
                        value={newPassword}
                        tabIndex="0"
                      />
                    </div>
                    <div class="form-group col-md-12">
                      <label className="form-label">
                        Confirm Password<span class="text-danger">*</span>
                      </label>

                      <input
                        className="form-control"
                        type="password"
                        placeholder="Confirm Password"
                        onChange={(e) => setNewConfirmPassword(e.target.value)}
                        value={newConfirmPassword}
                        tabIndex="0"
                      />
                    </div>
                  </div>
                  {newPassword.length <= newConfirmPassword.length &&
                  newPassword.length &&
                  newConfirmPassword.length &&
                  passwordValid ? (
                    <>
                      {passwordsMatch && newPassword.length && passwordValid ? (
                        <div className="alert alert-success">
                          Passwords match.
                        </div>
                      ) : (
                        <div className="alert alert-danger">
                          Passwords do not match or are invalid.
                        </div>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  {!passwordValid && (
                    <div
                      className={
                        passwordValid
                          ? "alert alert-success my-2"
                          : "alert alert-danger my-2"
                      }
                    >
                      {getValidationMessage()}
                    </div>
                  )}
                  <div className="row">
                    <div className="col-lg-12 d-flex justify-content-end">
                      {user_id ? (
                        <button
                          className="btn btn-btn2 btn-btn"
                          onClick={() => navigate("/dashboard/dashboardMain")}
                          tabIndex="0"
                        >
                          Cancel
                        </button>
                      ) : (
                        <button
                          className="btn btn-btn2 btn-btn"
                          onClick={() => navigate("/")}
                          tabIndex="0"
                        >
                          Cancel
                        </button>
                      )}
                      {passwordsMatch && newPassword.length && passwordValid ? (
                        <button
                          className="btn btn-btn1 btn-btn ms-2"
                          onClick={changePassword}
                          tabIndex="0"
                        >
                          {isloading ? (
                            <img
                              src={Loading}
                              alt="loaderImg"
                              width={20}
                              height={20}
                            ></img>
                          ) : (
                            "Save"
                          )}
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default UpdatePassword;
